import React from 'react';
import { FormatNumberOptions, useIntl } from 'react-intl';
import { Unit } from '../stores';
import { HTMLSelect, IHTMLSelectProps } from './Select';
import { formatUnit } from './FormattedUnit';

export const UnitSelect: React.FC<
  IHTMLSelectProps & { unitDisplay?: FormatNumberOptions['unitDisplay'] }
> = ({ unitDisplay, ...props }) => {
  const intl = useIntl();

  return (
    <HTMLSelect
      {...props}
      options={Object.values(Unit).map((unit) => ({
        value: unit,
        label: formatUnit(intl, unit, unitDisplay),
      }))}
    />
  );
};
